module.exports = __webpack_public_path__ + "img/glasses-12.cbfcb725.svg";